type Props = {
  title: string
  data: number
  icon: any
}

export const MeetingCard = ({ title, data, icon }: Props) => {
  return (
    <div className="flex gap-7 items-center w-full px-3 sm:px-7 py-6 border-solid border-grey-100 border-1 rounded-xl shadow-[0_4.74191px_11.8548px_rgba(0,0,0,0.05)]">
      <div className="hidden lg:flex">{icon}</div>
      <div className="flex flex-col gap-3">
        <p className="text-sm sm:text-lg text-grey-800">{title}</p>
        <p className="text-2xl font-medium text-grey-900">{data}</p>
      </div>
    </div>
  )
}
